import { createSelector } from "@reduxjs/toolkit";

/*
Helper to decide:
Is parti (ErpItemNumber) currently selected for SelectedFrameArea in Uterum
*/

const isFrameAreaChecked = (type, ErpItemNumber, Uterum) => {
  const { Partier, SelectedFrameArea, SelectedTopWindow } = Uterum;

  const area = type === "frame" ? SelectedFrameArea : SelectedTopWindow;

  if (!Partier || Partier.length === 0) {
    return null;
  }

  return Partier.find(
    (parti) => parti.ErpItemNumber === ErpItemNumber && parti.AreaCn === area
  )
    ? true
    : false;
};

/*
  Returns array of partier to render with a customized data structure:

   {
    erpItemNumber: "123456",
    model: "WINDOW",
    numberOfDoors: "4", // Note: string, can be empty
    imgSrc: `${assetBaseUrl}/store/uterumsguide2016/parts/WINDOW_4`
  }

*/

export const selectPartierToRender = createSelector(
  (state) => state,
  (state) => {
    const { init, Uterum, Options } = state;

    const { assetBaseUrl } = init;
    const { FrameType, SelectedFrameArea, SelectedTopWindow } = Uterum;
    const { Partier } = Options;

    if (!Partier || Partier.length === 0) {
      return null;
    }

    const partiObj = Partier.find((parti) => {
      return parti.AreaCn === SelectedFrameArea;
    });
    const topPartiObj = Partier.find((parti) => {
      return parti.AreaCn === SelectedTopWindow;
    });

    if (!partiObj) {
      return null;
    }

    const partierArray = [];
    const topPartierArray = [];

    let isFrameAreaToWideForWallOption = false;

    /*
    Option(s) for default partier
    */
    if (partiObj.PartierModels) {
      partiObj.PartierModels.forEach((parti) => {
        const {
          ErpItemNumber,
          PartierModel,
          PartierWidth,
          PartierNumberofdoors,
        } = parti;
        partierArray.push({
          erpItemNumber: ErpItemNumber,
          model: PartierModel,
          numberOfDoors: PartierNumberofdoors,
          imgSrc: `${assetBaseUrl}/store/uterumsguide2016/parts/${PartierModel}_${PartierNumberofdoors}.png`,
          checked: isFrameAreaChecked("frame", ErpItemNumber, Uterum),
        });

        const width = parseInt(PartierWidth);

        // Logic from Scensum backend, consider moving into CGE
        isFrameAreaToWideForWallOption = width && width > 4200;
      });
    }

    if (topPartiObj && topPartiObj.PartierModels) {
      topPartiObj.PartierModels.forEach((parti) => {
        const { ErpItemNumber, PartierModel, PartierNumberofdoors } = parti;

        topPartierArray.push({
          erpItemNumber: ErpItemNumber,
          model: PartierModel,
          numberOfDoors: PartierNumberofdoors,
          imgSrc: `${assetBaseUrl}/store/uterumsguide2016/parts/${PartierModel}_${PartierNumberofdoors}.png`,
          checked: isFrameAreaChecked("frameTop", ErpItemNumber, Uterum),
        });

        // Logic from Scensum backend, consider moving into CGE
      });
    }

    /*
    Option for wall (PANEL_DOOR)
    */

    if (
      !isFrameAreaToWideForWallOption &&
      // Logic from Scensum backend, consider moving into CGE
      !partiObj.AreaCn.includes("PITCHED") &&
      !partiObj.AreaCn.includes("_TOP") &&
      partiObj.WallErpItemNumber &&
      partiObj.WallErpItemNumber.length
    ) {
      partierArray.push({
        erpItemNumber: partiObj.WallErpItemNumber,
        model: "PANEL_DOOR",
        numberOfDoors: "0",
        imgSrc: `${assetBaseUrl}/store/uterumsguide2016/parts/WALL.png`,
        checked: isFrameAreaChecked(
          "frame",
          partiObj.WallErpItemNumber,
          Uterum
        ),
      });
    }

    const disableOptionForRemoval =
      FrameType === "FIRAXL" && partiObj.AreaCn.includes("TOP");

    /*
    Option for removal (EMPTY)

    Note:
    Empty is not a model, just a way of telling CGE that nothing should be selected
    */
    if (!disableOptionForRemoval) {
      partierArray.push({
        erpItemNumber: "",
        model: "EMPTY",
        numberOfDoors: "",
        imgSrc: `${assetBaseUrl}/store/uterumsguide2016/remove.png`,
        checked: isFrameAreaChecked("frame", "", Uterum),
      });
    }
    if (topPartiObj) {
      topPartierArray.push({
        erpItemNumber: "",
        model: "EMPTY",
        numberOfDoors: "",
        imgSrc: `${assetBaseUrl}/store/uterumsguide2016/remove.png`,
        checked: isFrameAreaChecked("frameTop", "", Uterum),
      });
    }

    return { partierArray, topPartierArray };
  }
);
